import { render } from "./CarThumbUp.vue?vue&type=template&id=4245a16b&scoped=true"
const script = {}

import "./CarThumbUp.vue?vue&type=style&index=0&id=4245a16b&scoped=true&lang=css"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4245a16b"]])

export default __exports__